import React, { useState, useRef, useEffect } from "react";
import { instanceOf, number, string } from "prop-types";

import Modal from "../../components/Modal/Modal.jsx";

const propTypes = {
  content: instanceOf(HTMLCollection).isRequired, // HTML collection of Elements https://developer.mozilla.org/en-US/docs/Web/API/Element
  scrollDepth: number,
  lang: string,
  dir: string,
};

const EmailSignupModalApp = (props) => {
  const { content, scrollDepth, lang, dir } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [modalListening, setModalListening] = useState(true);

  const contentRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      contentRef.current.innerHTML = "";
      [...content].forEach((c) => {
        contentRef.current.append(c);
      });
    }, 0);
  }, [content]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTriggerPoint =
        scrollDepth > 0
          ? (document.body.clientHeight - window.innerHeight / 2) *
            (scrollDepth / 100)
          : document.body.clientHeight - window.innerHeight / 2;

      if (window.scrollY > scrollTriggerPoint) {
        setModalOpen(true);
      }
    };

    if (modalListening) {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [modalListening, scrollDepth]);

  const handleClose = (e) => {
    e.preventDefault();
    setModalOpen(false);
    setModalListening(false);
    window.sessionStorage.setItem("hideInterstitial", true);
  };

  return (
    <Modal
      className="modal--form"
      isOpen={modalOpen}
      title={false}
      onClose={handleClose}
      lang={lang}
      dir={dir}
    >
      <div
        className="email-signup email-signup--interstitial"
        ref={contentRef}
      ></div>
    </Modal>
  );
};

EmailSignupModalApp.propTypes = propTypes;
export default EmailSignupModalApp;
